import {
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
} from '../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { toString1pkumu07cwy4m as toString } from '../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Unit_instance3vdlo4e4f5ggx as Unit_instance } from '../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { ensureNotNull1e947j3ixpazm as ensureNotNull } from '../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  fromInt2ii0rejb1w62w as fromInt,
  add2suhfggl4zvkk as add,
  subtract2orl8z9upxd9l as subtract,
} from '../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import { AutoCloseable1l5p57f9lp7kv as AutoCloseable } from '../../../kotlin-kotlin-stdlib/kotlin/AutoCloseableJs.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var PeekSourceClass;
function PeekSource() {
  if (PeekSourceClass === VOID) {
    class $ {
      constructor(upstream) {
        this.c4h_1 = upstream;
        this.d4h_1 = this.c4h_1.u3v();
        this.e4h_1 = this.d4h_1.e4f_1;
        var tmp = this;
        var tmp0_safe_receiver = this.d4h_1.e4f_1;
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.m4f_1;
        tmp.f4h_1 = tmp1_elvis_lhs == null ? -1 : tmp1_elvis_lhs;
        this.g4h_1 = false;
        this.h4h_1 = 0n;
      }
      f4g(sink, byteCount) {
        // Inline function 'kotlin.check' call
        if (!!this.g4h_1) {
          var message = 'Source is closed.';
          throw IllegalStateException().o(toString(message));
        }
        // Inline function 'kotlinx.io.checkByteCount' call
        // Inline function 'kotlin.require' call
        if (!(byteCount >= 0n)) {
          var message_0 = 'byteCount (' + byteCount.toString() + ') < 0';
          throw IllegalArgumentException().n2(toString(message_0));
        }
        // Inline function 'kotlin.check' call
        if (!(this.e4h_1 == null || (this.e4h_1 === this.d4h_1.e4f_1 && this.f4h_1 === ensureNotNull(this.d4h_1.e4f_1).m4f_1))) {
          var message_1 = 'Peek source is invalid because upstream source was used';
          throw IllegalStateException().o(toString(message_1));
        }
        if (byteCount === 0n)
          return 0n;
        // Inline function 'kotlin.Long.plus' call
        var this_0 = this.h4h_1;
        var tmp$ret$7 = add(this_0, fromInt(1));
        if (!this.c4h_1.b3w(tmp$ret$7))
          return -1n;
        if (this.e4h_1 == null && !(this.d4h_1.e4f_1 == null)) {
          this.e4h_1 = this.d4h_1.e4f_1;
          this.f4h_1 = ensureNotNull(this.d4h_1.e4f_1).m4f_1;
        }
        // Inline function 'kotlin.comparisons.minOf' call
        var b = subtract(this.d4h_1.q2(), this.h4h_1);
        var toCopy = byteCount <= b ? byteCount : b;
        this.d4h_1.x4f(sink, this.h4h_1, add(this.h4h_1, toCopy));
        this.h4h_1 = add(this.h4h_1, toCopy);
        return toCopy;
      }
      l6() {
        this.g4h_1 = true;
      }
    }
    initMetadataForClass($, 'PeekSource', VOID, VOID, [AutoCloseable()]);
    PeekSourceClass = $;
  }
  return PeekSourceClass;
}
//region block: exports
export {
  PeekSource as PeekSource3frbthc9yehpr,
};
//endregion

//# sourceMappingURL=PeekSource.mjs.map
